export class Slot {
    startsOn: Date
    endsOn: Date

    constructor(startsOn: Date, endsOn: Date) {
        this.startsOn = startsOn
        this.endsOn = endsOn
    }
}